import { useQuery } from "@tanstack/react-query";
import { fetch } from "@/src/lib/fetch";
import { YachtLabel } from "../app/Yachts/EditYacht/model";

export function useOperatorLabelsData(yachtId: String | undefined) {
  const { data: operatorsLabelsData, isLoading: isLoadingOperatorLabels } = useQuery({
    queryKey: ["operatorsLabelsData", yachtId],
    queryFn: () => fetch<YachtLabel[]>(`/api/yachts/${yachtId}/labels`).then((res) => res),
    enabled: !!yachtId,
  });

  const data = { ...operatorsLabelsData };

  return {
    operatorsLabelsData: operatorsLabelsData,
    isLoadingOperatorLabels: isLoadingOperatorLabels,
    isLoading: isLoadingOperatorLabels,
    data: data,
  };
}
